<div class="backdrop show" (click)="onCloseForm()"></div>

<div class="sidepanel show">
  <div class="header">
    <span>{{ isCreateMode ? 'Create Application' : 'Edit Application' }}</span>
    <nx-icon [name]="'close'" size="s" (click)="onCloseForm()"></nx-icon>
  </div>

  <div class="body">
    @if (applicationForm && !isApplicationLoading && responseError?.errorType !== 'loadApplication') {
    <form [formGroup]="applicationForm">
      @if (!isCreateMode) {
      <nx-formfield appearance="outline" label="Application ID" floatLabel="always">
        <input nxInput formControlName="applicationId" readonly />
      </nx-formfield>
      }
      <nx-formfield appearance="outline" label="Application Name" floatLabel="always">
        <input nxInput formControlName="applicationName"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Contact Email" floatLabel="always">
        <input nxInput type="email" formControlName="contactEmail"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Email Distributions" floatLabel="always">
        <input nxInput #addEmailDistributionInput
          (keydown.enter)="$event.preventDefault(); addEmailToDistributions(addEmailDistributionInput.value, addEmailDistributionInput)"
          (keydown.space)="$event.preventDefault(); addEmailToDistributions(addEmailDistributionInput.value, addEmailDistributionInput)"
          (keydown.,)="$event.preventDefault(); addEmailToDistributions(addEmailDistributionInput.value, addEmailDistributionInput)"
          [readonly]="!(permissionService.can_write_service_config$ | async)"
          placeholder="Type email and press Enter, Space, or Comma to add" />
      </nx-formfield>
      <nx-taglist [(tags)]="emailDistributions"
        [class.read-only]="!(permissionService.can_write_service_config$ | async)"></nx-taglist>

      @if (responseError && (responseError.errorType === 'updateApplication' || responseError.errorType ===
      'createApplication')) {
      <nx-message context="error">
        <span class="nx-font-weight-bold">{{ responseError.error }}</span><br />
        {{ responseError.details }}
      </nx-message>
      }
      @if (permissionService.can_write_service_config$ | async) {
      <button nxButton="primary small" type="button" [class.has-spinner]="isApplicationUpdating"
        [disabled]="!applicationForm.valid" (click)="updateApplication(addEmailDistributionInput)">
        @if (isApplicationUpdating) {
        <nx-spinner size="medium"></nx-spinner>
        }
        {{ isCreateMode ? 'Create Application' : 'Update Application' }}
      </button>
      }
    </form>
    }

    @if (responseError && responseError.errorType === 'loadApplication') {
    <nx-message context="error">
      <span class="nx-font-weight-bold">{{ responseError.error }}</span><br />
      {{ responseError.details }}
    </nx-message>
    }

    @if (isApplicationLoading) {
    <nx-spinner size="large"></nx-spinner>
    }
  </div>
</div>